import loadGoogleMapsApi from 'load-google-maps-api';

export default function() {
    return loadGoogleMapsApi({
        key: 'AIzaSyCK-Ys5cnnUJUMdDVuvBkZ_G2UKC35PImE',
    });
}
